import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/gripfire': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M171.8 503.8C171.8 498.5 176.6 491.6 176.6 481.5 176.6 466.3 163.6 441.6 98.5 394.9 64.2 365.8 32 336.4 32 286.6 32 171.9 179.1 110.1 179.1 18 179.1 14.7 178.9 11.3 178.5 8 183.6 10.4 217.6 51.3 217.6 98.4 217.6 178.9 112.5 227.6 112.5 301.4 112.5 328.3 129.1 348.6 145.1 370.9 167.6 401.1 189.3 427.8 189.3 457.4 189.2 471.9 184.9 487.1 171.8 503.8zM317.8 262.4C319.3 270.8 320 279 320 287 320 338.8 290.6 384.5 252.7 423.8 251.7 424.8 250.5 426.2 249.5 426.2 245.9 426.2 214 384.6 214 373 214 373 255.8 317.3 255.8 276.1 255.8 265.3 253.1 254.4 246.7 242.7 245.2 275 191 330.4 188.6 330.4 185.9 330.4 170.7 308.4 170.7 288.3 170.7 283 171.7 277.6 173.9 272.5 176.3 267 230.5 200.5 230.5 155.8 230.5 149.6 229.5 143.8 227.1 138.7L223.1 131.5C239.8 138 305.7 195.6 317.8 262.4'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/gripfire.js
// module id = a7Av
// module chunks = 144